
import { Component, Vue } from "vue-property-decorator";
import { AsOf, AsOfType, AsOfData, AsOfRelativeUnit } from "../../store/types";
import utilsService from '../../services/utils.service';
import moment from 'moment';

enum FocusedSide { Left, Right }
type MomentOffsetUnit = 'days' | 'weeks' | 'months' | 'years';

@Component({
  components: {
  }
})
export default class DateSelectModal extends Vue {

  public FocusedSide = FocusedSide;

  get asOfError(): string | undefined {
    return this.$store.state.profiles.asOfError;
  }

  get maxDate() {
    return this.$store.state.options.maxAsOf ? new Date(this.$store.state.options.maxAsOf) : new Date();
  }
  get minDate() {
    return this.$store.state.options.minAsOf ? new Date(this.$store.state.options.minAsOf) : null;
  }
  get minDateAsOffsetValue() {
    if (this.minDate) {
      const now = moment();
      let momentType: MomentOffsetUnit = this.offsetUnit + 's' as MomentOffsetUnit;
      return now.diff(this.minDate, momentType);
    }

    return null;
  }
  get maxDateAsOffsetValue() {
    if (this.maxDate) {
      const now = moment();
      let momentType: MomentOffsetUnit = this.offsetUnit + 's' as MomentOffsetUnit;
      return now.diff(this.maxDate, momentType) + 1;
    }

    return null;
  }

  get relativeValueError() {
    const asOf = {
      type: AsOfType.Relative,
      data: { count: this.offset, unit: this.offsetUnit }
    };

    const date = utilsService.convertAsOfToDate(asOf);
    const time = date.getTime();

    const min = this.$store.getters.getMinTime;
    const max = this.$store.getters.getMaxTime;
    const asOfError = utilsService.isDateOutsideRange(time, min, max);

    if (asOfError) {
      return `The relative date selected must be between ${this.maxDateAsOffsetValue} and ${this.minDateAsOffsetValue} ${this.offsetUnit}s ago (inclusive).`;
    }

    return null;
  }

  public date: Date | null = null;
  public offset: number = 0;
  public offsetUnitList: AsOfRelativeUnit[] = Object.values(AsOfRelativeUnit);
  public offsetUnit: AsOfRelativeUnit = AsOfRelativeUnit.Day;
  public focusedSide: FocusedSide = FocusedSide.Right;
  public manualMonthToShow: any = {};

  public cancel() {
    if (this.asOfError) {
      this.$store.commit('setAsOfError');
      this.$store.dispatch('clearSelections');
      this.$store.commit('setisLoadingFromProfile', false);
    }

    this.closeModal();
  }

  public closeModal() {
    this.$store.commit('setModal', '');
  }

  public save() {
    let asOf: AsOf;

    if (this.focusedSide === FocusedSide.Left) {
      const date = this.date ? new Date(this.date.getTime() - this.date.getTimezoneOffset() * 60000) : new Date();
      asOf = { type: AsOfType.Static, data: date.toISOString().slice(0,10) };
    } else {
      asOf = {
        type: AsOfType.Relative,
        data: { count: this.offset, unit: this.offsetUnit }
      };
    }

    if (this.asOfError) {
      this.$store.commit('setAsOfError');
      this.$store.commit('setisLoadingFromProfile', false);
    }
    this.$store.commit('setAsOf', asOf); 
    this.closeModal();
  }

  public datePickerUpdated(e: any) {
    this.date = e;
  }

  public mounted() {
    const asOf: AsOf = this.$store.getters.getAsOf;

    switch (asOf.type) {
      case AsOfType.Relative:
        const { count, unit } = asOf.data as AsOfData;
        this.offset = count;
        this.offsetUnit = unit;
        this.focusedSide = FocusedSide.Right;
        break;

      case AsOfType.Static:
        this.focusedSide = FocusedSide.Left;
        const date = new Date(asOf.data as string);
        this.manualMonthToShow = {
          month: date.getMonth() + 1,
          year: date.getFullYear()
        }
        const calendar = this.$refs.calendar as any;
        calendar.adjustPageRange();

        if (!this.asOfError) {
          this.date = date;
        }

        break;
    }
  }
}
